import { trendTopics } from "@/mocks/news";

export default function Trend() {
  return (
    <section id="trend" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* ranked list */}
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-line-chart-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              热度实时更新
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">热点话题榜</h2>

            <ol className="mt-7 divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {trendTopics.map((t) => (
                <li key={t.id} className="flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
                      t.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {t.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-[15px] font-medium text-foreground-950">
                      <a href="#trend" className="hover:text-primary-600">{t.title}</a>
                    </h3>
                    <span className="text-xs text-foreground-500">热度 {t.heat}</span>
                  </div>
                  <span
                    className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${
                      t.up ? "bg-accent-100 text-accent-900" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i
                      className={`${t.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} w-3 h-3 flex items-center justify-center`}
                      aria-hidden="true"
                    ></i>
                    {t.delta}
                  </span>
                </li>
              ))}
            </ol>
          </div>

          {/* side callout */}
          <aside className="flex flex-col gap-5">
            <div className="rounded-2xl bg-secondary-600 p-6 text-secondary-50 md:p-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50/15 px-3 py-1 text-xs font-medium text-secondary-50">
                <i className="ri-shield-check-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                我们的立场
              </span>
              <h3 className="mt-4 text-lg font-bold text-white">理性吃瓜，快乐聊天</h3>
              <p className="mt-3 text-sm leading-relaxed text-secondary-100">
                追热点讲分寸：不追踪个人隐私、不以讹传讹、不标题党。每一条快讯都会标注时间与归属，让你放心吃瓜，也能安心转发。
              </p>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-question-line text-lg w-5 h-5 flex items-center justify-center text-accent-600"></i>
                热点是怎么排出来的
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                榜单综合社交讨论量、搜索增长与阅读热度，并定期人工复核，过滤掉低质与标题党内容，尽量让真实、有话题价值的信息浮到前排。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {["讨论量", "搜索增量", "阅读热度", "人工复核"].map((k) => (
                  <span key={k} className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                    {k}
                  </span>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}